import React from 'react'

import { FormsElementTypeEnum, ProcurementTypeItemFragment } from 'generated/resources/graphql'

import { Form, FormEditor } from 'modules/forms'

const PERMITTED_FIELD_TYPES: FormsElementTypeEnum[] = [
  'longtext',
  'multiselect',
  'number',
  'section',
  'select',
  'text',
  'url',
  'dropdownsingle',
  'date',
]

interface Props {
  requestType: ProcurementTypeItemFragment
  form?: Form
}

const FormTab = ({ form }: Props) => {
  if (!form) {
    return null
  }
  return (
    <FormEditor
      formId={form.id}
      resourceType="Procurement::Type"
      permittedFieldTypes={PERMITTED_FIELD_TYPES}
      showElementName={false}
      titleSize="small"
    />
  )
}

export default FormTab
